import { render, staticRenderFns } from "./d-reviewer-search-number-results.vue?vue&type=template&id=41628c02&scoped=true&"
import script from "./d-reviewer-search-number-results.vue?vue&type=script&lang=js&"
export * from "./d-reviewer-search-number-results.vue?vue&type=script&lang=js&"
import style0 from "./d-reviewer-search-number-results.vue?vue&type=style&index=0&id=41628c02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41628c02",
  null
  
)

export default component.exports